(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodContextMenu', sodContextMenu);

    function sodContextMenu(KeyTrackingService, lodash, $compile) {
        return {
            restrict: 'EA',
            scope: {
                contextMenuEvents: '=?',
                contextMenuDataEvent: '=?',
                position: '@?',
            },
            templateUrl: 'common/components/sod-context-menu',
            transclude: true,
            controller: sodContextMenuCtrl,
            bindToController: true,
            controllerAs: 'vm',
            link: sodContextMenuLink,
        };

        function sodContextMenuCtrl() {
            var vm = this;
        }

        function sodContextMenuLink (scope, element, attrs) {
            var sodContextMenuCtrl = scope.vm;
            var hasContextMenuElement = false;

            element.on('click', function(event) {
                event.preventDefault();
                if (KeyTrackingService.hasNewTabCombinationKeyCode()) {
                    toggleContextMenu();
                }
            });

            document.addEventListener('mousedown', onMouseDown);

            function onMouseDown(event) {
                if (hasContextMenuElement) {
                    event.preventDefault();
                    resetNewTab();
                }
            }

            scope.$on('$destroy', function () {
                document.removeEventListener('mousedown', onMouseDown);
                if (contextMenuInstance) {
                    contextMenuInstance.destroy();
                }
            });

            element.bind('contextmenu', function(event) {
                event.preventDefault();
                toggleContextMenu();
            });

            function resetNewTab() {
                setTimeout(function () {
                    toggleContextMenu();
                }, 120);
            }

            function clearSelection() {
                if (document.selection && document.selection.empty) {
                    document.selection.empty();
                } else if (window.getSelection) {
                    var sel = window.getSelection();
                    sel.removeAllRanges();
                }
            }

            var contextMenuInstance = null;
            var contextMenu = element.find('.context-menu');
            contextMenu = $(contextMenu);
            contextMenu.hide();

            function initContextMenu() {
                contextMenuInstance = new Popper(element.children()[0], contextMenu, Object.assign({
                    placement: 'auto-start',
                    // originalPlacement: 'bottom',
                    onCreate: function () {
                        contextMenuInstance.update();
                    },
                }, lodash.get(scope, 'options', {})));
            }

            function updateContextMenu() {
                contextMenuInstance.update();
            }

            function toggleContextMenu() {
                if (!contextMenuInstance) {
                    initContextMenu();
                }

                var newTabElm = element.find('.context-menu');
                if (newTabElm.length > 0) {
                    var selectedNewTabElm = newTabElm[0];
                    var activeClass = 'active';

                    if (!selectedNewTabElm.classList.contains(activeClass)) {
                        selectedNewTabElm.classList.add(activeClass);
                        hasContextMenuElement = true;
                    } else {
                        selectedNewTabElm.classList.remove(activeClass);
                        hasContextMenuElement = false;
                    }
                }

                contextMenu.toggle();
                updateContextMenu();
                clearSelection();
            }
        }
    }
})();